document.addEventListener("DOMContentLoaded", function(event) {
    let r = document.querySelector(':root');
    const checkbox = document.querySelector("#dm-checkbox");
    let background_color = '',
        ghost_accent_color = '',
        color_darker_gray = '',
        color_secondary_text = '',
        color_white = '',
        brandcolor = '',
        excerpt_color = '';
    const background_color_dark = '#0d2746',
        ghost_accent_color_dark = '#f8f5d7',
        color_darker_gray_dark = '#ebeef0',
        color_secondary_text_dark = '#ebeef0',
        color_white_dark = '#000000',
        brandcolor_dark = '#f8f5d7',
        excerpt_color_dark = '#cfcfcf';
    // Create a function for getting a variable value
    const myFunction_get = () => {
        // Get the styles (properties and values) for the root
        var rs = getComputedStyle(r);
        // get colors
        background_color = rs.getPropertyValue('--background-color');
        ghost_accent_color = rs.getPropertyValue('--ghost-accent-color');
        color_darker_gray = rs.getPropertyValue('--color-darker-gray');
        color_secondary_text = rs.getPropertyValue('--color-secondary-text');
        color_white = rs.getPropertyValue('--color-white');
        brandcolor = rs.getPropertyValue('--brandcolor');
        excerpt_color = rs.getPropertyValue('--excerpt-color');
        //alert("The value of --background-color is: " + rs.getPropertyValue('--background-color') + "\n" + "The value of --ghost-accent-color is: " + rs.getPropertyValue('--ghost-accent-color') + "\n" + "The value of --color-darker-gray is: " + rs.getPropertyValue('--color-darker-gray') + "\n" + "The value of --color-secondary-text is: " + rs.getPropertyValue('--color-secondary-text'));
    };
    myFunction_get();
    const myFunction_set = () => {
        // Set the value of variable --blue to another value (in this case "lightblue")
        const logoHeaderImgHeader = document.querySelector('.gh-navigation-brand').querySelector('img');
        const logoHeaderImgFooter = document.querySelector('.footer-logo-wrap').querySelector('img');
        if(checkbox.checked){
            r.style.setProperty('--background-color', background_color);
            r.style.setProperty('--ghost-accent-color', ghost_accent_color);
            r.style.setProperty('--color-darker-gray', color_darker_gray);
            r.style.setProperty('--color-secondary-text', color_secondary_text);
            r.style.setProperty('--color-white', color_white);
            r.style.setProperty('--brandcolor', brandcolor);
            r.style.setProperty('--brandcolor', brandcolor);
            r.style.setProperty('--excerpt-color', excerpt_color);
            logoHeaderImgHeader.setAttribute('src', '/assets/images/Sabia_logoBirdLateralP.png');
            logoHeaderImgFooter.setAttribute('src', '/assets/images/Sabia_logoBirdLateralP.png');
            if(document.querySelector('.gh-form-input')){
                document.querySelector('.gh-form-input').classList.remove('gh-form-input__placeholder-white');
            }
            const images_products_light = document.querySelectorAll('.gh-card-link-imagem-light');
            images_products_light.forEach(image => {
                image.classList.add('active');
            });
            const images_products_dark = document.querySelectorAll('.gh-card-link-imagem-dark');
            images_products_dark.forEach(image => {
                image.classList.remove('active');
            });
        }else {
            r.style.setProperty('--background-color', background_color_dark);
            r.style.setProperty('--ghost-accent-color', ghost_accent_color_dark);
            r.style.setProperty('--color-darker-gray', color_darker_gray_dark);
            r.style.setProperty('--color-secondary-text', color_secondary_text_dark);
            r.style.setProperty('--color-white', color_white_dark);
            r.style.setProperty('--brandcolor', brandcolor_dark);
            r.style.setProperty('--excerpt-color', excerpt_color_dark);
            logoHeaderImgHeader.setAttribute('src', '/assets/images/SabiaLogoBirdLateralW.png');
            logoHeaderImgFooter.setAttribute('src', '/assets/images/SabiaLogoBirdLateralW.png');
            if(document.querySelector('.gh-form-input')){
                document.querySelector('.gh-form-input').classList.add('gh-form-input__placeholder-white');
            }
            const images_products_light = document.querySelectorAll('.gh-card-link-imagem-light');
            images_products_light.forEach(image => {
                image.classList.remove('active');
            });
            const images_products_dark = document.querySelectorAll('.gh-card-link-imagem-dark');
            images_products_dark.forEach(image => {
                image.classList.add('active');
            });
        }
    };
    checkbox.addEventListener("change", () => {
        document.cookie = `darkmode-prefered=${checkbox.checked};path=/`
        myFunction_set();
    });

    const getCookie = (cname) => {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "none";
    };
    const checkCookie = () => {
        let preference = getCookie("darkmode-prefered");
        if (preference != "none") {
            if (preference == "true") { 
                checkbox.checked = true;
                myFunction_set();
            } else {
                checkbox.checked = false;
                myFunction_set();
            }
        } else {
            if (window.matchMedia("(prefers-color-scheme:dark)").matches) {
                checkbox.checked = false;
                myFunction_set();
            } else {
                checkbox.checked = true;
                myFunction_set();
            }
        }
    };
    checkCookie();
});